import { TUseTranslationTfn } from "../data/AppType";
import { numberRangeSchema, prepareMessageFromParams } from "./AppFunctions";

interface INumberRangeOption {
  fieldName: string;
  min: number;
  max: number;
}

export const requiredNumberRangeSchema = (
  t: TUseTranslationTfn,
  { fieldName, min, max }: INumberRangeOption,
) => {
  const requiredMessage = prepareMessageFromParams(t("error_message_required"), [
    ["fieldName", fieldName],
  ]);
  return numberRangeSchema(t, fieldName, min, max)
    .transform((value: number, originalValue: unknown) =>
      originalValue === "" ? undefined : value,
    )
    .typeError(requiredMessage)
    .required(requiredMessage);
};
